module.exports = __webpack_public_path__ + "img/mockup_shadow_20.d82010e.png";